<template>
    <div id="questions" v-if="!loading">
        <DynamicScroller :items="list" :min-item-size="200" class="scroller" page-mode @update="handleScroll" :emitUpdate="true" :buffer="1000">
            <template v-slot="{ item, index, active }">
                <DynamicScrollerItem :item="item" :active="active" :data-index="index" :size-dependencies="[item]" :emitResize="true">
                    <QuestionPost :item="item" :list="list" :is-feed="false" block-title="Основной вопрос" :show-item="false" :has-delete="false" :topic-global-id="7"></QuestionPost>
                </DynamicScrollerItem>
            </template>
        </DynamicScroller>
    </div>
</template>

<script>
    import {questionsService} from "../../../_api/questions.service";
    import QuestionPost from "../../feed/QuestionPostBody";
    import {parsePostBody} from "../../../_helpers/post-body-parser";

    export default {
        name: 'closed-questions',
        props: {
            topicId: Number,
            searchStr: String,
            activeSearch: Boolean
        },
        data () {
            return {
                loading: true,
                list: [],
                loadIndexThreshold: 10,
                loadIndex: 10,
                page: 0
            }
        },
        components: {
            QuestionPost
        },
        computed: {},
        methods: {
            handleScroll(startIndex, endIndex) {
                if (endIndex === this.loadIndex) {
                    this.loadIndex += this.loadIndexThreshold;
                    (!this.searchStr.length) ? this.getQuestions(this.topicId) : this.searchQuestions(this.topicId, this.searchStr);
                }
            },
            getQuestions(top_id) {
                questionsService.getClosedQuestions({
                    page: (!this.page) ? 1 : this.page + 1,
                    topic_id: top_id !== 9999999 ? top_id : null
                }).then((res) => {
                    if (res) {
                        res.data.forEach(obj => {
                           parsePostBody(obj).then(res_q => {
                               res_q['has_answer'] = res_q.answers.some(i => {
                                   if (i.checked) {
                                       res_q['selected'] = i;
                                   }
                                   return i.checked;
                               });
                               res_q['title'] = 'Основной вопрос';
                               res_q['has_answer_mode'] = res_q['has_answer'];
                               this.list.push(res_q);
                               this.$forceUpdate();
                           });

                        });
                        if (res.data.length) {
                            this.page = res.current_page;
                        }
                    }
                    console.log(this.list);
                    this.loading = false;
                });
            },
            searchQuestions(top_id, search_str) {
                questionsService.searchQuestionsAPI({
                    page: (!this.page) ? 1 : this.page + 1,
                    perPage: 10,
                    topic_id: top_id !== 9999999 ? top_id : null,
                    query: search_str,
                    type: 'closed', // opened/closed/blank if all,
                    is_day: 0
                }).then((res) => {
                    if (res) {
                        res.data.forEach(obj => {
                            parsePostBody(obj).then(res_q => {
                                res_q['has_answer'] = res_q.answers.some(i => {
                                    if (i.checked) {
                                        res_q['selected'] = i;
                                    }
                                    return i.checked;
                                });
                                res_q['title'] = 'Основной вопрос';
                                res_q['has_answer_mode'] = res_q['has_answer'];
                                this.list.push(res_q);
                            });
                        });
                        if (res.data.length) {
                            this.page += 1;
                        }
                    }
                    this.loading = false;
                });
            },
            resetPage(id) {
                this.page = 0;
                this.list = [];
                this.loadIndex = this.loadIndexThreshold;
            }
        },
        created() {
            if (!this.activeSearch) {
                this.getQuestions(this.topicId);
            }
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
    #questions {}
</style>

